interface TypeNotification {
  key: string;
  name: string;
}

const TYPES_NOTIFICATIONS = {
  DOCUMENTS: 'documents',
  MASURI: 'masuri',
  CONTROALE: 'controale',
  // ACTIUNI: 'actiuni',
  HOTARARI: 'hotarari',
  CURTECONTURI: 'curteconturi',
  LITIGATIONS: 'litigations',
  AUDITS: 'audits'
};

const types_notifications = [
  { key: 'documents', name: 'Adaugare documente' },
  { key: 'masuri', name: 'Măsuri/recomandări la termen' },
  { key: 'controale', name: 'Controale curte de conturi' },
  { key: 'litigations', name: 'Litigii' },
  { key: 'audits', name: 'Audit' }

  // { key: 'actiuni', name: 'Acțiuni instanță' },
  // { key: 'hotarari', name: 'Hotărâri judecătorești' }
];

const types_notifications_admin = [
  // { key: 'controale', name: 'Controale curte de conturi' },
  { key: 'hotarari', name: 'Hotărâri judecătorești' },
  { key: 'curteconturi', name: 'Curtea de conturi' }
];
export { types_notifications, TYPES_NOTIFICATIONS, types_notifications_admin };
export type { TypeNotification };
